import {UserPreferences} from "../util/userPreferences";

export const usePreferences = () => UserPreferences.Instance;
